import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { apiUrl } from "../constants/urls";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})


export class PlantsService {
  constructor(private http: HttpClient) {}

  getByFilter(pageSize: number, pageNumber: number, searchText = "") {
    return this.http.get(
      `${apiUrl}/plants/Search?pageSize=${pageSize}&pageNumber=${pageNumber}&searchText=${searchText}`
    );
  }

  getAll() {
    return this.http.get(`${apiUrl}/plants`);
  }

  get(id: string) {
    return this.http.get(`${apiUrl}/plants/${id}`);
  }

  create(data: object) {
    return this.http.post(`${apiUrl}/plants`, data);
  }

  update(data: object): Observable<object> {
    return this.http.put(`${apiUrl}/plants`, data);
  }

  delete(id: string) {
    return this.http.delete(`${apiUrl}/plants/${id}`);
  }
}
